var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ZSchemaValidatorFactory } from "./angular2-schema-form-shim";
var ZSchema = require('z-schema');
import * as rawJSONSchemaMeta from '../schemas/schema.json';
var SPSchemaValidatorFactory = (function (_super) {
    __extends(SPSchemaValidatorFactory, _super);
    function SPSchemaValidatorFactory() {
        var _this = _super.call(this) || this;
        _this.zschema = new ZSchema({
            breakOnFirstError: false,
        });
        var metaSchemas = [
            rawJSONSchemaMeta,
        ];
        metaSchemas.forEach(function (metaSchema) { return _this.addRemoteReference(metaSchema.id, metaSchema); });
        return _this;
    }
    SPSchemaValidatorFactory.prototype.createValidatorFn = function (schema) {
        var _this = this;
        return function (value) {
            // Entire current property is missing, don't try to validate it directly, let the parent handle it
            if (_this.isPropertyMissing(value, schema)) {
                return null;
            }
            value = _this.cleanupValue(value, schema);
            _this.zschema.validate(value, schema);
            var err = _this.zschema.getLastErrors();
            _this.fixPropertyPaths(err, schema);
            return err || null;
        };
    };
    SPSchemaValidatorFactory.prototype.cleanupValue = function (value, schema) {
        value = this.deleteNullProperties(value, schema);
        if (schema.type === 'number' || schema.type === 'integer') {
            value = +value;
        }
        return value;
    };
    SPSchemaValidatorFactory.prototype.isPropertyMissing = function (value, schema) {
        if (Array.isArray(schema.type) && schema.type.includes('null') && value === null) {
            return true;
        }
        return (((value === null || value === '') && schema.type === 'string') ||
            (value === null && (schema.type === 'number' || schema.type === 'integer' || schema.type === 'boolean')));
    };
    SPSchemaValidatorFactory.prototype.deleteNullProperties = function (values, schema) {
        for (var property in values) {
            if (values.hasOwnProperty(property) && this.isPropertyMissing(values[property], schema)) {
                delete values[property];
            }
            else if (schema.type === 'array') {
                if (schema.items instanceof Array) {
                    values[property] = this.deleteNullProperties(values[property], schema.items[property]);
                }
                else {
                    values[property] = this.deleteNullProperties(values[property], schema.items);
                }
            }
            else if (values[property] === null && schema.properties && schema.properties[property] &&
                this.isPropertyMissing(null, schema.properties[property])) {
                delete values[property];
            }
            else if (typeof values[property] === 'object') {
                values[property] = this.deleteNullProperties(values[property], schema.properties[property]);
            }
        }
        return values;
    };
    SPSchemaValidatorFactory.prototype.fixPropertyPaths = function (err, schema) {
        if (err && err.length) {
            err = err.map(function (error) {
                if (error.path === '#/' && schema.path) {
                    error.path = schema.path;
                }
                // Required property errors are technically an error on the parent.
                // Move the error to the missing property instead for ease of display.
                if (error.code === 'OBJECT_MISSING_REQUIRED_PROPERTY') {
                    error.code = 'PROPERTY_VALUE_REQUIRED';
                    error.path += (error.path === '#/' ? '' : '/') + error.params[0];
                }
                return error;
            });
        }
    };
    return SPSchemaValidatorFactory;
}(ZSchemaValidatorFactory));
export { SPSchemaValidatorFactory };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/schemavalidatorfactory.ts.pre-build-optimizer.js